/**
 * If name is for example "muitas_tehniskais_aprikojums$89173"
 * number after # will be returned as string
 */

const readIdFromName = (name: string | undefined): string =>
	!!name ? name.slice(name.lastIndexOf("$") + 1) : ""

export default readIdFromName
